<template>
  <BContainer
    v-if="user"
    fluid
  >
    <BRow
      class="pb-5 mx-1"
    >
      <BCol
        cols="12"
        class="px-0"
      >
        <BRow
          class="py-1 mx-0"
        >

          <BCol
            cols="12"
            class="p-2 border-bottom"
          >
            <h5 class="text-center text-md-left font-weight-bold">
              Purchase Orders
            </h5>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'rm.purchase-orders.approvals', params: { approver: 'pending' }}">
              <Card
                :loading="fetching"
                :count="purchaseOrders.pending"
                title="Pending"
                sub-title="PO Approvals"
                variant="dark"
                icon="fad fa-file-lines"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'rm.purchase-orders.approvals', params: { approver: 'histories', status: 'approved' }}">
              <Card
                :loading="fetching"
                :count="purchaseOrders.approved"
                title="Approved"
                sub-title="PO Approvals"
                variant="success"
                icon="fad fa-file-check"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'rm.purchase-orders.approvals', params: { approver: 'histories', status: 'disapproved' }}">
              <Card
                :loading="fetching"
                :count="purchaseOrders.disapproved"
                title="Disapproved"
                sub-title="PO Approvals"
                variant="danger"
                icon="fad fa-file-times"
              />
            </router-link>
          </BCol>

        </BRow>
      </BCol>

      <BCol
        cols="12"
        class="px-0"
      >
        <BRow
          class="py-1 mx-0"
        >

          <BCol
            cols="12"
            class="p-2 border-bottom mt-4"
          >
            <h5 class="text-center text-md-left font-weight-bold">
              Inter Branches
            </h5>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'rm.inter-branches.approvals', params: { approver: 'pending' }}">
              <Card
                :loading="fetching"
                :count="interBranches.pending"
                title="Pending"
                sub-title="IB Approvals"
                variant="dark"
                icon="fad fa-file-lines"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'rm.inter-branches.approvals', params: { approver: 'histories', status: 'approved' }}">
              <Card
                :loading="fetching"
                :count="interBranches.approved"
                title="Approved"
                sub-title="IB Approvals"
                variant="success"
                icon="fad fa-file-check"
              />
            </router-link>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <router-link :to="{ name: 'rm.inter-branches.approvals', params: { approver: 'histories', status: 'disapproved' }}">
              <Card
                :loading="fetching"
                :count="interBranches.disapproved"
                title="Disapproved"
                sub-title="IB Approvals"
                variant="danger"
                icon="fad fa-file-times"
              />
            </router-link>
          </BCol>

        </BRow>
      </BCol>

    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import Card from '@/components/custom/Card.vue'

import { SRMDashboard } from '@/services/rm'

export default {

  name: 'VRetailManagerDashboard',

  middleware: ['auth', 'rm'],

  components: {
    Card
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      borderRight: !this.isMobile(),
      purchaseOrders: {
        pending: 0,
        disapproved: 0,
        approved: 0
      },
      interBranches: {
        pending: 0,
        disapproved: 0,
        approved: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  mounted () {
    if (this.user) {
      this.getStatistics()
    }
  },

  methods: {
    async getStatistics () {
      this.fetching = true
      return SRMDashboard.getStatistics().then(({ data }) => {
        this.purchaseOrders.pending = data.purchase_order_approval_total_pending
        this.purchaseOrders.approved = data.purchase_order_approval_total_approved
        this.purchaseOrders.disapproved = data.purchase_order_approval_total_disapproved

        this.interBranches.pending = data.inter_branch_approval_total_pending
        this.interBranches.approved = data.inter_branch_approval_total_approved
        this.interBranches.disapproved = data.inter_branch_approval_total_disapproved
      }).catch(() => {
        this.purchaseOrders.pending = 0
        this.purchaseOrders.approved = 0
        this.purchaseOrders.disapproved = 0

        this.interBranches.pending = 0
        this.interBranches.approved = 0
        this.interBranches.disapproved = 0
      }).finally(() => {
        this.fetching = false
      })
    }
  }
}
</script>
